module.exports = __webpack_public_path__ + "img/main_background.9c7d2ac5.png";